(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.ys-promo .rotating-heading:not([data-rotation-ready])').forEach(heading => {
    heading.dataset.rotationReady = 'true';
    const slides = [...heading.querySelectorAll('.headline-slide')];
    let index = 0, visible = false, timer, transition;
    const stop = () => { clearInterval(timer); clearTimeout(transition); slides[index].classList.add('is-active'); };
    const update = () => {
      stop();
      if (!visible || document.hidden || motion.matches) return;
      timer = setInterval(() => {
        slides[index].classList.remove('is-active');
        transition = setTimeout(() => {
          index = (index + 1) % slides.length;
          slides[index].classList.add('is-active');
        }, 220);
      }, 3000);
    };
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); }, {threshold: 0.1}).observe(heading);
    document.addEventListener('visibilitychange', update);
    motion.addEventListener('change', update);
  });
})();
